import { useState, useEffect, useCallback } from 'react'

import { Card, CardContent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SettlementsTable from './SettlementsTable'
import PageTitle from '../../Misc/PageTitle'
import { toast } from 'react-toastify'
import AppFilters from '../../AppFilters'
import Filters from './Filters'
import useIsMounted from '../../../hooks/useIsMounted';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate'


export default function SettlementsList() {
    const { t } = useTranslation()

    const isMounted = useIsMounted()

    const api = useAxiosPrivate()

    const [params, setParams] = useState({})

    const [data, setData] = useState([])

    const [fetchingData, setFetchingData] = useState(false)

    const [loading, setLoading] = useState(true)

    const [meta, setMeta] = useState({
        total_pages: 1,
        current_page: 1
    })

    const handleOnSearch = values => {
        setLoading(true)

        setParams(values)
    }

    const handleOnPageChange = (e, page) => {
        setLoading(true)

        setMeta({ ...meta, current_page: page })
        setParams({ ...params, page: page })
    }

    const handleExportCsv = (id) => {
        setFetchingData(true)

        return api.get(`/internal/withdrawals/${id}/export/`)
            .then(response => {
                if (isMounted()) {
                    const headers = response.headers

                    const regexp = new RegExp(/filename=(.*)/)
                    const match = headers.hasOwnProperty('content-disposition') ? headers['content-disposition'].match(regexp) : ''
                    const filename = match.length > 1 ? match[1] : 'transactions.csv'

                    const binaryData = []

                    binaryData.push(response.data)

                    let anchor = document.createElement('a')

                    anchor.href = window.URL.createObjectURL(new Blob(binaryData, { type: "text/csv" }))

                    anchor.download = filename

                    anchor.click()

                    anchor.remove()
                }
            })
            .catch(() => isMounted() && toast.error(t('Something went wrong')))
            .finally(() => isMounted() && setFetchingData(false))
    }

    const handleExportPdf = (id, filename) => {
        setFetchingData(true)

        return api.get(`/internal/withdrawals/${id}/pdf-invoice/`, { responseType: 'blob' })
            .then((response) => {
                if (isMounted()) {
                    let anchor = document.createElement('a')

                    anchor.href = window.URL.createObjectURL(response.data)

                    anchor.download = `${filename}.pdf`

                    anchor.click()

                    anchor.remove()
                }
            })
            .catch(() => isMounted() && toast.error(t('Something went wrong')))
            .finally(() => isMounted() && setFetchingData(false))
    }

    const retrieveData = useCallback(() => {
        setData([])

        api.get('/internal/withdrawals/completed/', { params: params })
            .then(({ data: { data, meta } }) => {
                if (isMounted()) {
                    setData(data)
                    setMeta(meta)
                }
            })
            .catch(() => isMounted() && toast.error(t('Something went wrong')))
            .finally(() => isMounted() && setLoading(false))
    }, [params, t, isMounted, api])

    useEffect(() => {
        const loadData = () => {
            retrieveData()
        }

        loadData()
    }, [params, retrieveData])

    return (
        <>
            <Card>
                <CardContent>
                    <PageTitle title={t('Payment list')} />

                    <AppFilters Filters={<Filters handleOnSearch={handleOnSearch} />} />

                    <SettlementsTable
                        data={data}
                        pages={meta.total_pages}
                        page={meta.current_page}
                        loading={loading}
                        fetchingData={fetchingData}
                        handleOnPageChange={handleOnPageChange}
                        handleExportPdf={handleExportPdf}
                        handleExportCsv={handleExportCsv}
                    />
                </CardContent>
            </Card>
        </>
    )
}
